"use client";

import { Box, Typography } from "@mui/material";
import { useAppTranslate } from "src/hooks/useAppTranslate";
import type { MobilePlatform } from "src/utils/in-app-browser";
import { OpenInBrowserActions } from "./index";

/**
 * Stands in for the Google / Apple buttons inside a social app's in-app
 * browser. Google refuses OAuth in embedded WebViews (`disallowed_useragent`)
 * and the popup opens as a window with no opener, so the button looked like
 * it did nothing. One line saying why, and the same way out as the banner;
 * email and guest checkout stay where they are.
 */
export function InAppSignInNotice({
  platform,
  withApple = false,
}: {
  platform: MobilePlatform;
  withApple?: boolean;
}) {
  const t = useAppTranslate();
  return (
    <Box data-testid="in-app-sign-in-notice">
      <Typography variant="body2" color="text.secondary">
        {withApple
          ? t(
              "inAppBrowser.signInNeedsBrowserWithApple",
              "Za prijavo z Googlom ali Applom odprite stran v brskalniku.",
            )
          : t(
              "inAppBrowser.signInNeedsBrowser",
              "Za prijavo z Googlom odprite stran v brskalniku.",
            )}
      </Typography>
      <OpenInBrowserActions platform={platform} />
    </Box>
  );
}
